import api from '../../../services/api';

export async function buscarJurosAutomaticosBackend(idParcela) {
  console.log('[JUROS] Buscando juros automáticos para parcela:', idParcela);
  try {
    const resp = await api.get(`/parcelas/${idParcela}/juros-automaticos`);
    console.log('[JUROS] Resposta do backend:', resp.data);
    return resp.data; // { valor, percentual }
  } catch (error) {
    console.error('[JUROS] Erro ao buscar juros automáticos:', error);
    throw error;
  }
} 